import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import Header from './Header'

const Projects = () => {
  const [isSticky, setIsSticky] = useState(false);
  const listOfSlides = ['/img/js1.jpg', '/img/js2.jpg', '/img/js3.jpg', '/img/js4.jpg'];

  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          arrows: false
        }
      }
    ],
  };

  useEffect(() => {
    const block = document.getElementById("projects");
    const handleScroll = () => {
      if (block) {
        const rect = block.getBoundingClientRect();
        setIsSticky(rect.top <= 0); // Detect when top of block reaches the viewport top
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  return (
    <section className={`projects ${isSticky ? "sticky" : ""}`} id="projects">
      <Header />
      <div className="wrapper">
        <h2>Projects</h2>
        <div className="items">
          <div className="item">
            <Slider {...sliderSettings}>
              {listOfSlides.map((url, index) => (
                <img key={index} src={url} alt='slide' />
              ))}
            </Slider>

            <div className="container">
              <h3>Applegate</h3>
              <p>
                Landing page
              </p>
              <div className="links">
                <a href="https://applegate-web.vercel.app">Link</a>
              </div>
              <div className="tech-logos">
                <img src="/svg/react.svg" alt="" />
                <img src="/svg/nextjs.svg" alt="" />
                <img src="/svg/typescript.svg" alt="" />
                <img src="/svg/html-5.svg" alt="" />
                <img src="/svg/css-3.svg" alt="" />
                <img src="/svg/vercel.svg" alt="" />
                <img src="/svg/macOS.svg" alt="" />
              </div>
            </div>
          </div>

          <div className="item">
            <Slider {...sliderSettings}>
              {listOfSlides.map((url, index) => (
                <img key={index} src={url} alt='slide' />
              ))}
            </Slider>

            <div className="container">
              <h3>JobSnail</h3>
              <p>
                App designed to manage job applications and interviews, focusing on simplicity and functionality. It's available as a macOS desktop app and a web app.
              </p>
              <div className="links">
                <a href="https://www.jobsnail.app">Web version</a>
                <a href="https://lnkd.in/gtaqB3eW">MacOS version</a>
              </div>
              <div className="tech-logos">
                <img src="/svg/react.svg" alt="" />
                <img src="/svg/nextjs.svg" alt="" />
                <img src="/svg/typescript.svg" alt="" />
                <img src="/svg/html-5.svg" alt="" />
                <img src="/svg/css-3.svg" alt="" />
                <img src="/svg/vercel.svg" alt="" />
                <img src="/svg/macOS.svg" alt="" />
              </div>
            </div>
          </div>

          <div className="item">
            <img src="/img/pic1.jpg" alt="" />
            <div className="container">
              <h3>Bow Shock</h3>
              <p>
                Social media app designed to connect skaters, share content, and organize events and contests within the skateboarding community.
              </p>
              <div className="links">
                <a href="https://bowshock.app">bowshock.app</a>
              </div>
              <div className="tech-logos">
                <img src="/svg/ios.svg" alt="" />
                <img src="/svg/swift.svg" alt="" />
                <img src="/svg/uikit.svg" alt="" />
                <img src="/svg/firebase.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;